import { Pagination } from '@design-system';
import { FC } from 'react';

import { InsightItem } from '../../utils/journals/insights';
import { JournalsCard } from './JournalsCard';

interface InsightsGridProps {
  handleArticleClick: (article: InsightItem, index: number) => void;
  handlePaginationClick: (page: number) => void;
  pagination: {
    page: number;
    perPage: number;
    total: number;
  };
  stories: InsightItem[];
}

export const InsightsGrid: FC<InsightsGridProps> = ({
  handleArticleClick,
  handlePaginationClick,
  pagination,
  stories = [],
}) => (
  <main className="grid-section gap-y-6">
    {stories.map((story, index) => (
      <article className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3">
        <JournalsCard
          key={story.id}
          description={story.intro}
          eagerLoading={index === 0}
          href={`/${story.full_slug}`}
          image={story.image}
          imageRatio={story.ratio || '4/3'}
          mediaDuration={story.mediaDuration || ''}
          onClick={() => handleArticleClick(story, index)}
          publishedAt={story.date}
          readingTime={story.readingTime}
          tag={story.tag}
          title={story.title}
        />
      </article>
    ))}

    {Math.ceil(pagination.total / pagination.perPage) > 1 && (
      <div className="col-span-12 pt-3 md:pt-6">
        <Pagination
          currentPage={pagination.page}
          handleOnClick={handlePaginationClick}
          numPages={Math.ceil(pagination.total / pagination.perPage)}
          paginationUrl="/insights"
          queryParams=""
        />
      </div>
    )}
  </main>
);
